export default __webpack_public_path__ + "static/media/service7.c0421487.png";